var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "shipping-group-total-item" },
    [
      _c(
        "div",
        { staticClass: "shipping-group-total-item__label" },
        [_vm._t("label", [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")])],
        2
      ),
      _c("div", { staticClass: "shipping-group-total-item__separator" }),
      _vm.isPriceNumber && _vm.oldPrice && _vm.oldPrice > _vm.price
        ? _c("span", { staticClass: "shipping-group-total-item__old-price" }, [
            _vm._v("\n    " + _vm._s(_vm._f("price")(_vm.oldPrice)) + "\n  ")
          ])
        : _vm._e(),
      _c(
        "span",
        { staticClass: "shipping-group-total-item__price" },
        [
          _vm.isPriceNumber
            ? [_vm._v(_vm._s(_vm._f("price")(_vm.price)) + " ₽")]
            : [_vm._v(_vm._s(_vm.price))]
        ],
        2
      ),
      _vm._t("append")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }